export class DlgInfo {
  formName: string
  formData: any
  title: string
  width: string
  show: boolean
  top: string
  footerShow: boolean
  submitLoading: boolean
  uiStatus: number
  constructor() {
    this.formName = ''
    this.formData = {}
    this.title = ''
    this.width = '600px'
    this.show = false
    this.top = '15vh'
    this.footerShow = false
    this.submitLoading = false
    this.uiStatus = 0
  }
}

export default DlgInfo
